import COS from 'cos-js-sdk-v5'
import { Message } from 'element-ui'
import uploadProgress from '@/utils/uploadProgress'

const COS_BUCKET = 'new-1321666904'
const COS_REGION = 'ap-beijing'
const COS_DOMAIN = 'https://cos.xiaomimiart.com'
const COS_PROTOCOL = 'https:'

const cos = new COS({
  SecretId: 'AKIDpX1MUO6bsxoMglbCgx3vYw61tXw61jCR',
  SecretKey: '3rQkp57uc8UlpgJitpWebJuUikY7Ytzr',
  Protocol: COS_PROTOCOL,
  Timeout: 600000,
})

function normalizeKey(key) {
  return String(key || '').replace(/^\/+/, '')
}

function buildUrl(key) {
  const normalizedKey = normalizeKey(key)
  return `${COS_DOMAIN}/${normalizedKey}`
}

function getUploadErrorMessage(error) {
  if (!error) {
    return '文件上传失败，请稍后重试'
  }

  const cosError = error.error || {}
  const knownMessage =
    error.message ||
    cosError.Message ||
    cosError.message ||
    error.Code ||
    error.code

  if (knownMessage) {
    return `文件上传失败: ${knownMessage}`
  }

  return '文件上传失败，请稍后重试'
}

function putObject(key, file, options = {}) {
  const normalizedKey = normalizeKey(key)
  const progress = typeof options.progress === 'function' ? options.progress : null
  const trackProgress = options.track !== false
  const progressToken = trackProgress
    ? uploadProgress.start((file && file.name) || normalizedKey || '正在上传文件')
    : null

  return new Promise((resolve, reject) => {
    cos.putObject(
      {
        Bucket: COS_BUCKET,
        Region: COS_REGION,
        Protocol: COS_PROTOCOL,
        Key: normalizedKey,
        Body: file,
        onProgress(progressData) {
          const percent = typeof progressData.percent === 'number' ? progressData.percent : 0
          if (progress) {
            progress(percent)
          }
          if (trackProgress) {
            uploadProgress.update(percent * 100, progressToken)
          }
        },
      },
      (error, data) => {
        if (error) {
          const errorMessage = getUploadErrorMessage(error)
          if (trackProgress) {
            uploadProgress.finish(false, progressToken)
          }
          Message.error(errorMessage)
          reject(new Error(errorMessage))
          return
        }

        if (trackProgress) {
          uploadProgress.finish(true, progressToken)
        }
        resolve({
          ...data,
          name: normalizedKey,
          key: normalizedKey,
          url: buildUrl(normalizedKey),
        })
      }
    )
  })
}

export default {
  put: putObject,
}





// WEBPACK FOOTER //
// ./src/utils/ossClient.js